import axios, { AxiosResponse } from 'axios';
import { BACKENDURL, COUNTRIES_API_KEY, COUNTRIES_BASE_URL } from './constants';
import { userDispatch } from './localStorage';
import storageService from '../../../../Utils/storageService';

export const AppInstance = axios.create({
  baseURL: BACKENDURL,
});

export const AuthInstance = axios.create({
  baseURL: `${BACKENDURL}`,
});

/*
*
*
Auth API's
*
*
*/

export const getOtp: (email: string) => Promise<AxiosResponse<any>> = async (email: string) => {
  const path = `/v1/auth/send/otp`;
  const response: any = await AuthInstance.post(path, {}, { params: { email: email } });
  return response;
};

export const verifyOtp: (email: string, otp: string) => Promise<AxiosResponse<any>> = async (email: string, otp: string) => {
  const path = `/v1/auth/verify/otp`;
  const response: any = await AuthInstance.get(path, {
    params: { email: email, otp: otp },
  });
  return response;
};

export const userLogin: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = '/v1/auth/login/verify';
  const response: any = await AuthInstance.post(path, payload);
  return response;
};

export const updatePassword: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = '/v1/auth/update/password';
  const response: any = await AuthInstance.post(path, payload);
  return response;
};

export const getToken: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = '/v1/helper/getToken';
  const response: any = await AuthInstance.get(path, payload);
  return response;
};

/*
*
*
Application API's
*
*
* */

export const getFacilities: () => Promise<AxiosResponse<any>> = async () => {
  const path = '/v1/facility/get/facility';
  const response = AppInstance.get(path);
  return response;
};

export const getFacilityBookings: (id: string) => Promise<AxiosResponse<any>> = async (id: string) => {
  const path = `/v1/facility/get/facility/booking`;
  const response: any = AppInstance.get(path, { params: { id } });
  return response;
};

export const getFacilityDetails: (id: string) => Promise<AxiosResponse<any>> = async (id: string) => {
  const path = `/v1/facility/get/facility/ById`;
  const response = await AppInstance.get(path, { params: { id } });
  return response;
};

export const updateFacility: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = `/v1/facility/update/facility/booking`;
  const response = await AppInstance.post(path, payload);
  return response;
};

export const bookFacility: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = `/v1/facility/book/facility`;
  const response = await AppInstance.post(path, payload);
  return response;
};

export const getCouponCodes: (pricingIds: Array<string>, facility?: Array<string>) => Promise<AxiosResponse<any>> = async (pricingIds: Array<string>, facility?: Array<string>) => {
  const user = await storageService.getItem('user');
  const { applicantId: id } = typeof user === 'string' ? JSON.parse(user) : user;
  const path = `v1/facility/get/couponCode?id=${id||user?.id}&pricings=${pricingIds}&facilities=${facility}`;
  const response = await AppInstance.get(path);
  return response;
};

export const generatePayment: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = '/v1/payment/initiate/international/payment';
  const response = await AppInstance.post(path, payload);
  return response;
};

export const getBookings: () => Promise<AxiosResponse<any>> = async () => {
  const user = await storageService.getItem('user');
  const { applicantId: userId } = typeof user === 'string' ? JSON.parse(user) : user;
  const path = `/v1/facility/get/facility/booking?accountId=${userId||user?.id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getAllBookings: () => Promise<AxiosResponse<any>> = async () => {
  const path = `/v1/facility/get/facility/booking`;
  const response = await AppInstance.get(path);
  return response;
};

export const getExisitngBookings: (id: string) => Promise<AxiosResponse<any>> = async (id: string) => {
  const queryString: Array<string> = ['a0RH4000000QOoGMAW', 'a0RH4000000QOoFMAW', 'a0RH4000000QOpcMAG'];
  let paramsString;
  if (queryString.includes(id)) {
    paramsString = queryString
      .filter((items) => {
        return items !== id;
      })
      .map((id: string) => `subItemId=${encodeURIComponent(id)}`)
      .join('&');
  }
  const path = paramsString ? `/v1/facility/get/facility/booking?itemId=${id}&${paramsString}` : `/v1/facility/get/facility/booking?itemId=${id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getFacilityDiscounts: (itemId: string) => Promise<AxiosResponse<any>> = async (itemId: string) => {
  const user = await storageService.getItem('user');
  const { applicantId: userId } = typeof user === 'string' ? JSON.parse(user) : user;
  const path = `/v1/facility/get/facility/discount?itemId=${itemId}&accountId=${userId||user?.id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getImages: (id: string) => Promise<AxiosResponse<any>> = async (id: string) => {
  const path = `/v1/facility/get/images?id=${id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getPricing: (roomId: string) => Promise<AxiosResponse<any>> = async (roomId: string) => {
  const path = `/v1/facility/get/facility/pricing?roomId=${roomId}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getPolicyDetails: (id: string) => Promise<AxiosResponse<any>> = async (id: string) => {
  const path = `/v1/facility/get/policy/criterial?id=${id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getTransactions: () => Promise<AxiosResponse<any>> = async () => {
  const user = await storageService.getItem('user');
  const userData = typeof user === 'string' ? JSON.parse(user) : user;
  const { applicantId: userId } = userData;
  const path = `/v1/transaction/byId?accountId=${userId||userData?.id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getFacilityHomeRules: () => Promise<AxiosResponse<any>> = async () => {
  const path = `/v1/facility/get/facility/homerules`;
  const response: any = AppInstance.get(path);
  return response;
};

export const facilitiesChecking: (itemId: string, startTime: any, endTime: any, reschedule?: string, timeZone?: string) => Promise<AxiosResponse<any>> = async (itemId: string, startTime: string, endTime: string, reschedule?: string, timeZone?: string) => {
  const path = `/v1/facility/check/facility/booking?itemId=${itemId}&startDateTime=${startTime}&endDateTime=${endTime}&reschedule=${reschedule}${timeZone ? `&timeZone=${encodeURIComponent(timeZone)}` : ''}`;
  const respones = await AppInstance.get(path);
  return respones;
};

export const contactAdmin: (payload: any) => Promise<AxiosResponse<any>> = async (payload: any) => {
  const path = '/v1/facility/create_case';
  const response = await AppInstance.post(path, payload);
  return response;
};

export const getCertificates: () => Promise<AxiosResponse<any>> = async () => {
  const { id: user } = await userDispatch({ case: 'GET', key: 'user' });
  const path = `/v1/facility/get/facility/certificate?accountId=${user}`;
  const response = await AppInstance.get(path);
  return response;
};

export const thirdPartyBooking: (payload: any) => Promise<AxiosResponse> = async (payload: any) => {
  const path = '/v1/facility/book/thirdparty';
  const response = await AppInstance.post(path, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'multipart/form-data',
    },
  });
  return response;
};

export const memberShipOnboard: (payload: any) => Promise<AxiosResponse> = async (payload: any) => {
  const path = '/v1/payment/membership/initiate/international/payment';
  const response = await AppInstance.post(path, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'multipart/form-data',
    },
  });
  return response;
};

export const cancelRequest: (payload: any) => Promise<AxiosResponse> = async (payload: any) => {
  const path = '/v1/facility/request/cancellation';
  const response = await AppInstance.post(path, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'multipart/form-data',
    },
  });
  return response;
};

export const getLiabilityForm: () => Promise<AxiosResponse<any>> = async () => {
  const path = '/v1/facility/get/liabilityform';
  const respones = await AppInstance.get(path);
  return respones;
};
export const postThirdPartyFileUpload: (payload: any) => Promise<AxiosResponse<any>> = async (payload) => {
  const path = `/v1/facility/fileupload/thirdparty`;
  const response = await AppInstance.post(path, payload);
  return response;
};

export const updateThirdPartyFileUploadStatus: (payload: any) => Promise<AxiosResponse<any>> = async (payload) => {
  const path = `/v1/facility/update/fileupload/status`;
  const response = await AppInstance.post(path, payload);
  return response;
};

export const postAccessCardRequest: (payload: any) => Promise<AxiosResponse<any>> = async (payload) => {
  const path = `/v1/facility/account/${payload.accountId}`;
  const response = await AppInstance.patch(path, payload);
  return response;
};

export const getLiabilityPolicy: (payload: any) => Promise<AxiosResponse<any>> = async (id) => {
  const path = `/v1/facility/get/liability/policy/${id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getBookingQuestions: (facilityId: string) => Promise<AxiosResponse<any>> = async (facilityId: string) => {
  const path = `/v1/facility/get/booking/questions`;
  const response = await AppInstance.get(path, { params: { facilityId } });
  return response;
};
export const deleteCartItems: (bookingId: string) => Promise<AxiosResponse<any>> = async (bookingId) => {
  const path = '/v1/facility/delete/cart';
  const respones = await AppInstance.get(path, {
    params: {
      bookingId: bookingId,
    },
  });
  return respones;
};

export const updateLiabilityForm: (payload: any) => Promise<AxiosResponse> = async (payload: any) => {
  const path = '/v1/facility/update/liabilityform';
  const response = await AppInstance.post(path, payload);
  return response;
};

export const getUserDetails: () => Promise<AxiosResponse<any>> = async () => {
  const user = await storageService.getItem('user');
  const { applicantId: userId } = typeof user === 'string' ? JSON.parse(user) : user;
  const path = `/v1/auth/userdetails?id=${userId||user?.id}`;
  const response = await AppInstance.get(path);
  return response;
};

export const getDropDownDatas: (data: any) => Promise<AxiosResponse<any>> = async (data) => {
  const path = `/v1/helper/getDropDownValues?objectName=${data.objectName}&fieldName=${data.fieldName}`;
  const response = await AppInstance.get(path);
  return response;
};

export const postBookingFileUpload: (payload: any) => Promise<AxiosResponse<any>> = async (payload) => {
  const path = `/v1/facility/fileupload/booking`;
  const response = await AppInstance.post(path, payload);
  return response;
};

const axiosinstancecountries = axios.create({
  baseURL: COUNTRIES_BASE_URL,
  headers: {
    accept: 'application/json',
    'X-CSCAPI-KEY': COUNTRIES_API_KEY,
  },
});

export const getCountries = async () => {
  const path = 'v1/countries';
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};
